import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './../../pagescss/Subjects.css';
import subjects from './Subjects';
//import Questions from "../Database/Questions";
import AllQuestions from '../AllData/AllQuestions';
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';

function PracticQuestionSubjects(props) {




    const [savedQuestions, setSavedQuestions] = useState([]);
    // const {questions} = Questions();
    const questions = AllQuestions;

    useEffect(() => {
        const storedQuestions = JSON.parse(localStorage.getItem('saveQuestionsIdInLocalStorage')) || [];
        setSavedQuestions(storedQuestions);
    }, []);

    const CountTotalQuestions = (subject) => {
        return questions.filter(question =>
            (question.subject === subject || question.subjectcatagory === subject) &&
            question.type === props.type
        ).length;
    };


    const CountTotalQuestionSolved = (subject) => {
        const totalQuestions = questions.filter(question =>
            (question.subject === subject || question.subjectcatagory === subject) &&
            question.type === props.type
        );


        const solvedQuestionIds = totalQuestions.filter(question =>
            savedQuestions.some(saved => saved === question._id.$oid)
        ).map(question => question._id.$oid);

        return solvedQuestionIds.length;
    };


    const PercentageBar = ({ percentage }) => {
        const normalizedPercentage = Math.max(0, Math.min(100, percentage));
        let color;

        if (normalizedPercentage >= 90) {
            color = '#00ff08ff';
        } else if (normalizedPercentage >= 80) {
            color = '#a4ff3dff';
        } else if (normalizedPercentage >= 70) {
            color = '#d0ffa4ff';
        } else if (normalizedPercentage >= 60) {
            color = '#cebe2cff';
        } else if (normalizedPercentage >= 50) {
            color = '#b2b430ff';
        } else if (normalizedPercentage >= 40) {
            color = '#f8ec7dff';
        } else if (normalizedPercentage >= 30) {
            color = '#fff23fff';
        } else if (normalizedPercentage >= 20) {
            color = '#fab650ff';
        } else if (normalizedPercentage >= 10) {
            color = '#ff6363ff';
        } else {
            color = '#ff0707ff';
        }

        const containerStyle = {
            width: '100%',
            height: '20px',
            backgroundColor: '#e0e0e0',
            borderRadius: '10px',
            overflow: 'hidden',
            marginTop: '10px'
        };

        const fillStyle = {
            width: `${normalizedPercentage}%`,
            height: '100%',
            backgroundColor: color,
            transition: 'width 0.5s ease-in-out',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            paddingRight: '8px',
            boxSizing: 'border-box',
        };

        const textStyle = {
            color: normalizedPercentage > 40 ? '#fff' : '#333',
            fontWeight: 'bold',
            fontSize: '12px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };

        return (
            <div style={containerStyle}>
                <div style={fillStyle}>
                    {normalizedPercentage > 0 && (
                        <span style={textStyle}>{`${normalizedPercentage}`}{normalizedPercentage > 10 && (<>%</>)}</span>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className="subject-page">

            <TopNavbar name={props.name} />
            <TopHeader name={props.name} />


            <div className="subject-categories">
                {subjects.map((subject) => {
                    const subjectName = subject.subject;
                    const totalQuestions = CountTotalQuestions(subjectName);
                    const totalQuestionSolved = CountTotalQuestionSolved(subjectName);
                    // const totalQuestionSolved = savedQuestions.length;
                    const percentage = totalQuestions > 0 ? Math.round((totalQuestionSolved / totalQuestions) * 100) : 0;


                    return (
                        <Link
                            to={`/${props.link}/${subject.name.toLowerCase().replace(' ', '-')}`}
                            key={subject.id}
                            className="subject-card"
                            style={{ borderLeft: `5px solid ${subject.color}` }}
                        >
                            <div className="subject-card-header">
                                <div className="subject-icon" style={{ color: subject.color }}>
                                    {subject.icon}
                                </div>
                                <h2>{subject.name} ➔</h2>
                                <p>({totalQuestionSolved}/{totalQuestions})</p>
                            </div>
                            <PercentageBar percentage={percentage} />

                        </Link>
                    )
                })}
            </div>
        </div>


    );
}

export default PracticQuestionSubjects;